<div class="content-section" *ngIf="content$ | async as data; else loadingTpl">
  <ng-container *ngIf="data['Conoce-mas-sobre-la-reforma']?.beneficios?.['beneficios-cotizados'] as bc">
    <div class="description">
      <p *ngFor="let parrafo of bc.description" [innerHTML]="parrafo"></p>
    </div>

    <div class="infographic">
      <p class="visually-hidden">
        Montos referenciales: 10 años cotizados equivalen a 1 UF; 15 años a 1,5 UF; 20 años a 2 UF; y 25 años a 2,5 UF.
      </p>
      <icon-beneficios-anos-cotizados-infografia aria-hidden="true"></icon-beneficios-anos-cotizados-infografia>
    </div>

    <div class="conditions-box">
      <h3>{{ bc.conditionsTitle }}</h3>
      <p *ngFor="let condicion of bc.conditionsText" [innerHTML]="condicion"></p>
    </div>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="5"></app-text-skeleton>
</ng-template>